<template>
  <div class="sms-content-main">
    <div class="nav-container">
      <el-menu
        default-active="2"
        class="el-menu-vertical-demo"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b">
        <el-submenu index="1">
          <template slot="title">
            <span>安检机构</span>
          </template>
          <el-menu-item index="1-1">机构1</el-menu-item>
          <el-menu-item index="1-2">机构2</el-menu-item>
        </el-submenu>
        <el-menu-item index="2">
          <span slot="title">用户</span>
        </el-menu-item>
        <el-menu-item index="3">
          <span slot="title">角色</span>
        </el-menu-item>
        <el-menu-item index="4">
          <span slot="title">权限</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="content-container">
      <el-empty description="该页面还在努力建设中..."></el-empty>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>

<style lang="less" scoped>
.sms-content-main {
  display: flex;
  background-color: #fff;
  min-height: 700px;

  .nav-container {
    width: 15%;

    .el-menu-vertical-demo {
      height: 100%;
    }
  }

  .content-container {
    flex: 1
  }
}


</style>



// WEBPACK FOOTER //
// src/components/admin/Setting.vue